export const CompanyNameColumn = {
    companyName: 'Company Name',
};
export const CompanyNameColumnValidation = {
    [CompanyNameColumn.companyName]: { required: true },
};
export const CompanyNameColumnValidationEntries = Object.entries(CompanyNameColumnValidation);
export const CompanyNameColumnCount = CompanyNameColumnValidationEntries.length;
export const CompanyNameColumns = CompanyNameColumnValidationEntries.map(([columnName]) => columnName);
export const CompanyNameColumnsString = CompanyNameColumns.join(',');
export const CompanyNameColumnTemplate = Object.fromEntries(CompanyNameColumnValidationEntries.map(([columnName, columnConfig]) => {
    const values = [];
    if (columnConfig.required) {
        values.push('required');
    }
    return [columnName, values.length > 0 ? `(${values.join(', ')})` : ''];
}));
//# sourceMappingURL=companyNameColumns.js.map